$ = require('jquery')
ApiError = require 'app/scripts/network/api-error'
Auth = require 'app/scripts/db/auth'
DueDate = require 'app/scripts/views/home/due-date'
ModelCacheListener = require 'app/scripts/views/internal/model-cache-listener'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
React = require 'react'
SidebarState = require 'app/scripts/view-models/sidebar-state'
_ = require 'underscore'
moment = require 'moment'
{ trackUe } = require '@trello/analytics'
{ ContentSkeleton } = require './presentational/content-skeleton'
{ TeamCardsDueSection } = require './presentational/team-cards-due-section'
{ getScrollParent } = require('app/common/lib/dom/get-scroll-parent')

class TeamCardsDueContainer extends React.Component
  displayName: 'TeamCardsDueContainer'

  constructor: (props) ->
    super props

    @unresolvedPromises = new Set()
    @fetchDueDateCards = @fetchDueDateCards.bind(@)
    @setGroupRef = @setGroupRef.bind(@)
    @onClickGroup = @onClickGroup.bind(@)

    @state = {
      dueDateCards: []
      loading: true
      selectedGroup: 'overdue'
      isBoardsMenuPinned: SidebarState.getPinSidebar()
    }

    @groupRefs = {}

  componentDidMount: ->
    @cancelOnUnmount(new Promise((resolve) -> ModelLoader.waitFor('boardsData', resolve))).then =>
      @fetchDueDateCards().then (dueDateCards) =>
        @setState
          dueDateCards: dueDateCards
          loading: false
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e
        @setState
          loading: false

    @props.modelListener SidebarState, 'change', =>
      @setState isBoardsMenuPinned: SidebarState.getPinSidebar()

  componentDidUpdate: (prevProps, prevState) ->
    if prevState.loading && !@state.loading
      @setState(selectedGroup: 'overdue')

  componentWillUnmount: ->
    @unresolvedPromises.forEach((promise) -> promise.cancel())

  cancelOnUnmount: (promise) =>
    promise.cancellable()
    @unresolvedPromises.add(promise)
    promise.then => @unresolvedPromises.delete(promise)

    return promise

  setGroupRef: (groupName, groupRef) ->
    @groupRefs[groupName] = groupRef

  onClickGroup: (groupName) ->
    { orgId } = @props

    method = "by clicking scroll to #{groupName} button in due dates feed when filtered by team"
    context = { teamId: orgId }

    trackUe('home', 'scrolls to section', 'due dates feed', '', 'on team cards tab', method, context)

    @scrollIntoView(@groupRefs[groupName], groupName)

  setScrolledPastTab: (groupName) =>
    @setState(selectedGroup: groupName)

  scrollIntoView: (el, groupName) ->
    if !el
      return true

    $(getScrollParent(el)).animate({
      scrollTop: el.offsetTop - 8,
    }, => @setState(selectedGroup: groupName))

  fetchDueDateCards: ->
    { modelCache, orgId } = @props
    idMember = Auth.me().id

    @cancelOnUnmount(ModelLoader.loadOrgMemberCardData(orgId, idMember))
      .then (response) =>
        dueDateCards = response.map (card) =>
          list = modelCache.get('List', card.get('idList'))
          board = modelCache.get('Board', card.get('idBoard'))
          org = modelCache.get('Organization', orgId)

          return {
            boardId: board.id
            cardId: card.id
            dueComplete: card.get('dueComplete')
            dueDate: card.get('due')
            listId: list.id
            orgId: org.id
          }

        return _.sortBy(dueDateCards.filter((dueDateCard) => dueDateCard.dueDate && !dueDateCard.dueComplete), 'dueDate')

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

        console.error e
        []

  removeDueDateCard: (dueDateId) =>
    @setState (prevState) ->
      dueDateCards: prevState.dueDateCards.filter((dueDateCard) -> dueDateCard.cardId != dueDateId)

  renderDueDate: (dueDateCard) =>
    { cardId, listId, boardId, orgId } = dueDateCard
    { modelCache } = @props

    React.createElement DueDate, {
      boardId
      cardId
      key: cardId
      listId
      modelCache
      orgId
      @removeDueDateCard
    }

  getDueDateOf: (dueDateCard) =>
    card = @props.modelCache.get('Card', dueDateCard.cardId)
    return (card.getDueDate() || new Date()).getTime()

  render: ->
    { orgName, orgId } = @props
    { dueDateCards, loading, selectedGroup } = @state

    if loading
      React.createElement('div', {
        className: '.home-due-dates-loading-container'
      }, React.createElement(ContentSkeleton))
    else
      React.createElement('div', {
        className: '.home-due-dates-container'
      }, React.createElement(TeamCardsDueSection, {
          dueDateCards
          @getDueDateOf
          now: moment()
          @onClickGroup
          @renderDueDate
          selectedGroup
          @setGroupRef
          @setScrolledPastTab
          isBoardsMenuPinned: @state.isBoardsMenuPinned
        })
      )

module.exports = ModelCacheListener(TeamCardsDueContainer)
